module.exports = __webpack_public_path__ + "img/numbers_icon.ab9418f0.png";